import * as R from 'ramda';
import { mapActions, mapGetters } from 'vuex';

import { isValueExist } from '@util';

import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';

export default {
    data() {
        return {
            currentViewId: undefined,
            teamspaceId: undefined,
            lIsCurrentViewChanged: false,
        };
    },
    watch: {
        currentView: {
            immediate: true,
            handler(v) {
                const teamspaceId = R.path(['teamspace', 'id'], v);
                if (teamspaceId && this.teamspaceId !== teamspaceId) {
                    this.teamspaceId = teamspaceId;
                }
                if (v && v.id) {
                    this.getDimensionList();
                }
            },
        },
        ['currentView.id']: {
            immediate: true,
            handler(v) {
                if (this.currentViewId !== v) {
                    this.currentViewId = v;
                }
            },
        },
        isViewChanged: {
            immediate: true,
            handler(v) {
                if (this.lIsCurrentViewChanged !== v) {
                    this.lIsCurrentViewChanged = v;
                }
            },
        },
    },
    computed: {
        ...mapGetters('newDashboard', ['currentView']),
        ...mapGetters('newDashboard', {
            isViewChanged: 'isCurrentViewChanged',
        }),
    },
    methods: {
        ...mapActions('newDashboard', ['getDimensionList']),
        getCurrentViewWatcher$(duration = 200) {
            const { generateWatchNew$: gen$ } = this;

            return gen$('currentView', { deep: true }).pipe(
                debounceTime(duration),
                filter(isValueExist),
                distinctUntilChanged(R.eqProps('id'))
            );
        },
    },
};
